/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Architect_Output9Inputs */

const en_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bot architecture spec`)
};

const ar_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مواصفة بنية البوت`)
};

const bn_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বট আর্কিটেকচার স্পেসিফিকেশন`)
};

const de_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bot-Architekturspezifikation`)
};

const es_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificación de arquitectura del bot`)
};

const fr_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spécification d'architecture du bot`)
};

const pt_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Especificação de arquitetura do bot`)
};

const zh_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`机器人架构规范`)
};

const tr_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bot mimarisi şartnamesi`)
};

const ru_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спецификация архитектуры бота`)
};

const pl_svc_messaging_bots_architect_output9 = /** @type {(inputs: Svc_Messaging_Bots_Architect_Output9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Specyfikacja architektury bota`)
};

/**
* | output |
* | --- |
* | "Bot architecture spec" |
*
* @param {Svc_Messaging_Bots_Architect_Output9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_architect_output9 = /** @type {((inputs?: Svc_Messaging_Bots_Architect_Output9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Architect_Output9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_architect_output9(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_architect_output9(inputs)
	if (locale === "de") return de_svc_messaging_bots_architect_output9(inputs)
	if (locale === "es") return es_svc_messaging_bots_architect_output9(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_architect_output9(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_architect_output9(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_architect_output9(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_architect_output9(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_architect_output9(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_architect_output9(inputs)
	return en_svc_messaging_bots_architect_output9(inputs)
});
export { svc_messaging_bots_architect_output9 as "svc_messaging-bots_ARCHITECT_output" }